import React, { Component } from "react";
import * as prosConnect from "../prodect/ProsConnect";
import {prosNotificationShow} from "../prodect/ProsPopup";
import RenderReport from "./RenderReport";
import {
    ATTR_IS_PICTURES_ALLOWED,
    ATTR_OBJ_ID,
    createNewObsComment,
    getActiveProject,
    prosLog
} from "../prodect/ProsConnect";
import {prosLogDt} from "../prodect/ProsConnect";
import BasicButton from "../components/BasicButton";
import {setHelpContext} from "../prodect/HelpManager";
import LoadingAnimation from "../components/LoadingAnimation";
import * as projectLoader from "../prodect/ProjectLoader";
import {openPictureImportModal, renderNoCapacity} from "../prodect/ProsCommonUi";
import TextButton from "../components/TextButton";
import {getCopyMoveManager} from "../prodect/CopyMoveManager";
import {prosAppNotifDismiss} from "../prodect/ProsAppNotif";

export default class SettingLocationPictures extends Component {
    constructor(props) {
        super(props)
        this.state = {
            dragState: false,
            refreshCounter: 0,
            report: null
        }
        this.refreshUi = this.refreshUi.bind(this)
        this.notifFromReport = this.notifFromReport.bind(this)
    }

    async componentDidMount() {
        let project = prosConnect.getActiveProject()
        if (project) {
            prosLogDt('Selected project:', project.getPid())
            await project.awaitFixLocationPictureListSpacing()
            this.refreshUi()
        } else {
            prosLog('Project not restored')
        }
        projectLoader.loadCompleteProjectIfNeeded()
        projectLoader.subscribeRefreshUiWhenDataChanged(true, "SettingLocationPictures", (who) => this.onProjectDataChanged(who))
        setHelpContext('locPict')
    }

    onProjectDataChanged(who) {
        this.refreshUi()
    }

    refreshUi() {
        this.setState({
            isLoading: false,
            loadingUpdates: false,
            refreshCounter: this.state.refreshCounter + 1,
        })
        let project = prosConnect.getActiveProject()
        if (project) {
            this.setState({
                report: prosConnect.getActiveProject().getLocationPictureUiList()[0]
            })
        }
    }

    toggleDragState() {
        getCopyMoveManager().cancelOperations()
        prosAppNotifDismiss()
        const newDragState = !this.state.dragState
        this.setState( {
            dragState: newDragState
        })
        getCopyMoveManager().setRearrangeMode(newDragState)
    }

    renderDragToggle() {
        if(!this.hasLocationImages()) return null
        return <BasicButton
            btnClass={"2nd"}
            label={"Järjestele elementtejä"}
            icon={"reorder"}
            selected={this.state.dragState}
            tooltip={["Muuta kuvien ja tekstien järjestystä vetämällä", "tooltip-left_bottom" + (this.state.dragState ? " tooltip-active tooltip-notice" : "")]}
            action={()=>{
                this.toggleDragState()
            }}
            shrink={"lg"}
        />
    }

    notifFromReport(text, type, dismissByUser) {
        prosNotificationShow(this, text, type, dismissByUser)
    }

    hasLocationImages(){
        return this.state.report?.obsList?.length > 0
    }

    renderUiList() {
        if (this.state.isLoading) {
            return <LoadingAnimation size={"lg"} />
        }
        let project = prosConnect.getActiveProject()
        if (!project.isProjectLoaded()) {
            return <h3 className={"color-2nd"}>Ohjelmavirhe - projektin tietoja ei ole ladattu</h3>
        }
        //report.hasOwnProperty('obsList')
        if (!this.hasLocationImages()) {
            return <h3>Osaprojektissa ei ole sijaintikuvia</h3>
        } else {
            const report = this.state.report
            return <div className={"slab list-view"}>
                <div className={"list-view-item-content padding-0"}>
                    <div className={"grid-container grid-1 grid-2_lg"
                        + (this.state.dragState ? "___ reorder-active" : "")}>
                            <RenderReport
                                key={report.obj_id}
                                report={report}
                                refreshParentUi={this.refreshUi}
                                notif={this.notifFromReport}
                            />
                    </div>
                </div>
            </div>
        }
    }

    renderAddLocationPicOrComment(item) {
        if(!item || item?.ui_isHistoryItem || this.state.dragState){
            return null
        }
        if (!prosConnect.hasPermissionTo("addContent", undefined, undefined)) {
            return
        }
        let isAddingPictureAllowed = prosConnect.getActiveProject().isAllowed(ATTR_IS_PICTURES_ALLOWED)
        let reasonPictureNotAllowed = isAddingPictureAllowed ?
            undefined : ["Kuvien lisääminen projektiin on estetty", "tooltip-bottom"]
        if (getActiveProject().hasCapacityToAddItems(true)) {
            return <div className={"slab"}>
                <div className={"btn-set width-100 width-50_xl"}>
                    <BasicButton
                        btnClass={"2nd"}
                        label={"Lisää sijaintikuva"}
                        icon={"image-tack"}
                        action={() => {
                            openPictureImportModal(item)
                        }}
                        disabled={!isAddingPictureAllowed}
                        tooltip={reasonPictureNotAllowed}
                        shrink={"lg"}
                    />
                    <TextButton
                        btnClass={"primary"}
                        label={"Lisää kommentti"}
                        multiline={1}
                        onSubmit={val => createNewObsComment(item[ATTR_OBJ_ID], val)}
                        className={"flex-grow"}
                    />
                </div>
            </div>
        }
        return renderNoCapacity('kommenttia')
    }
    render() {
        return <>
            <header>
                <h1 className={"flex-grow"}>Sijaintikuvat</h1>
                {this.renderDragToggle()}
            </header>
            <section>
                {this.renderUiList()}
                {this.renderAddLocationPicOrComment(this.state.report)}
            </section>
        </>
    }
}
